import React, { useEffect, useState } from "react";
import logo from "../../images/Coloured.svg";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { db } from "../../config/firebase-config";
import {
  GoogleAuthProvider,
  getAuth,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { AiOutlineEye } from "react-icons/ai";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import { FcGoogle } from "react-icons/fc";
import { login, loginWithGoogle } from "../../../src/services/AuthService"
import { setNewUser } from "../../redux/actions/authActions";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailVal, setEmailVal] = useState(false);
  const [passVal, setPassVal] = useState(false);
  const [both, setBoth] = useState(false);
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [iswrongPassword, setIsWrongPassword] = useState(false);
  const [isUserNew, setIsUserNew] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const auth = getAuth();
  // const regex = "";
  // const queryClient = useQueryClient();
  const provider = new GoogleAuthProvider();
  const [isResend, setIsResend] = useState(false);
  const [resendLinkHidden, setResendLinkHidden] = useState(false);
  useEffect(() => {
    const keyDownHandler = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleSignIn();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [email, password]);

  const handleSignIn = () => {
    if (email !== "") {
      setLoading(true);
      signInUser();
    } else {
      setLoading(true);
      if (email === "" && password === "") {
        setBoth(true);
      } else if (password === "") {
        setPassVal(true);
      } else if (email === "") {
        setEmailVal(true);
      }
      setLoading(false);
    }
  };

  // console.log(window.location.origin+window.location.pathname)
  const signInUser = () => {
    if (email && password) {
      login(email, password,
        (response) => {
          let response_data = response.data;
          let emailVerified = response_data.emailVerified;
          if(emailVerified == true){
            let uid = response_data.localId;
            let idToken = response_data.idToken;
            let refreshToken = response_data.refreshToken;
            localStorage.setItem("@auth", uid);
            localStorage.setItem("uid", uid);
            localStorage.setItem("idToken", idToken)
            localStorage.setItem("refreshToken", refreshToken)
            navigate("/");
          } else {
            toast.error("Please verify email");
            setLoading(false);
          }
          setLoading(false);
        }, (error) => {
          let errorObject = error.response.data;
          let status = errorObject.status;
          if(["INVALID_PASSWORD"].indexOf(status) != -1){
            setIsWrongPassword(true);
            setIsResend(true);
          }else if(["INVALID_EMAIL"].indexOf(status) != -1){
            toast.error("New user please signup.");
            setIsUserNew(true);
          }else if(status.indexOf("TOO_MANY_ATTEMPTS_TRY_LATER") != -1){
            toast.error(status);
          }else{
            toast.error(status);
          }
          setLoading(false);
        })
    } else {
      if (password === "") {
        setPassVal(true);
      }
      setLoading(false);
    }
  };

  return (
    <div className="xl:w-[35%]  mx-auto  md:w-[50%] w-[80%] sm:w-[60%]">
      <div className="pb-[15px]">
        <img
          src={logo}
          className="xl:w-[300px] md:w-[250px] w-[200px] mx-auto"
          alt=""
        />
      </div>
      <div className=" border-[2px] border-[white] py-[20px] rounded-[10px] shadow">
        <div className="mx-[10%]">
          <div className="md:text-2xl text-xl font-semibold">Welcome Back!</div>

          <button
            onClick={() => {
              loginWithGoogle({
                auth, provider, dispatch, setNewUser, navigate
              })
            }}
            className="border w-full flex hover:scale-105 hover:shadow-md shadow-sm transition items-center justify-center gap-[20px] text-black py-[10px] text-lg rounded-md my-[15px]"
          >
            {/* Login with  <div><b className='text-[#0086f9]'>G</b><b className='text-[#ff4131]'>o</b><b className='text-[#febd00]'>o</b><b className='text-[#0086f9]'>g</b><b className='text-[#00aa4a]'>l</b><b className='text-[#ff4131]'>e</b></div> <FcGoogle /> */}
            <FcGoogle className="text-2xl" /> Login with Google
          </button>
          <div className="text-center text-gray-400">OR</div>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailVal(false);
              setBoth(false);
              setIsUserNew(false);
            }}
            className="outline-0 pb-[5px] border-b-[2px] border-[#577D86] md:text-[16px] text-[14px] w-[100%] mt-[10px]"
          />
          {emailVal && (
            <div className={emailVal && "wrong"}>Please enter email</div>
          )}
          {both && <div className={both && "wrong"}>Please enter email</div>}
          <div className="flex justify-between relative items-center border-b-[2px] border-[#577D86]  w-[100%] ">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setIsWrongPassword(false);
                setPassVal(false);
                setBoth(false);
              }}
              placeholder="Password"
              className=" pb-[5px] w-[80%] outline-0 mt-[10px] md:text-[16px] text-[14px]"
            />
            <label
              className="relative top-[10px] right-[20px]"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <AiOutlineEyeInvisible className="md:h-[18px] h-[15px] md:w-[18px] w-[15px]" />
              ) : (
                <AiOutlineEye className="md:h-[18px] h-[15px] md:w-[18px] w-[15px]" />
              )}
            </label>
          </div>
          {isUserNew && <div className="wrong">New User, Please Signup</div>}
          {iswrongPassword && (
            <div className={iswrongPassword && "wrong"}>Incorrect password</div>
          )}
          {passVal && (
            <div className={passVal && "wrong"}>Please enter password</div>
          )}
          {both && (
            <div className={both && "wrong"}> Please enter password</div>
          )}
          <button
            onClick={handleSignIn}
            className="w-[100%] bg-[#576CBC] text-[white] py-[2%] rounded-[5px] md:text-[18px] text-[13px] text-center my-[10px]"
          >
            {loading ? <CircularProgress color="inherit" /> : "Login"}
          </button>

          <div className="text-center text-[#577D86] md:text-[16px] text-[14px] md:mb-0 mb-[10px]">
            Don't have an account?{" "}
            <button
              onClick={() => {
                navigate(`/signup?emailId=${email}`);
              }}
              className="text-[#576CBC] md:text-[16px] text-[14px] transition underline hover:drop-shadow-md"
            >
              Sign up
            </button>
          </div>
          <div className="flex items-center justify-center gap-[10px] mt-[10px]">
            {/* {!resendLinkHidden && (
              <button
                className="text-xs text-center text-[#576CBC]"
                onClick={() => {
                  sendLink();
                }}
              >
                Resend Verification Link
              </button>
            )} */}
            {isResend && (
              <button
                className="text-xs text-center text-[#576CBC]"
                onClick={() => {
                  sendPasswordResetEmail(auth, email)
                    .then(() => {
                      setIsResend(false);
                      toast.success("Mail sent for resetting password");
                    })
                    .catch((error) => {
                      setIsResend(true);
                      if (email === "") {
                        toast.error("Please enter email");
                        // ..
                      } else {
                        toast.error("New User, Please Signup");
                      }
                    });
                }}
              >
                Forgot Password?
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
